export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  return error as string;
}

export function convertObjectToSearchParams(source?: any): URLSearchParams | null {
  if (!source) {
    return null;
  }

  const sourceObj = {
    ...source,
  };

  return new URLSearchParams(sourceObj);
}

export function appendDataToUrl(url: string, data?: any): string {
  const params = convertObjectToSearchParams(data);
  return appendQueryParamsToUrl(url, params);
}

export function appendQueryParamsToUrl(url: string, params?: URLSearchParams | null): string {
  if (!params) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${params.toString()}`;
}

export function randomNumber(min = 1, max = 1000): number {
  const rnd = Math.random() * (max - min) + min;
  return Math.round(rnd);
}

export function truncate(input: string | null, max: number): string | null {
  if (!input || input.length <= max) {
    return input;
  }

  let truncated = input.substring(0, max - 3);
  truncated = `${truncated}...`;
  return truncated;
}
